import editor from './Editor.vue';
import extend from 'lodash/extend';
import AudioPlayer from '@/components/basic/audio-player/AudioPlayer';

export default {
  template: '<span>dummy for testing</span>',
  components: {
    editor,
    AudioPlayer,
  },
  props: [
    'active',
    'item',
    'first',
    'last',
    'lesson',
    'section',
    'summaryOnly',
    'taking',
    'testing',
  ],
  data() {
    return {
      _calculating: false,
      imageRatio: 0,
      forceRecalc: Date.now(),
    };
  },
  computed: {
    val() {
      return this.item.values;
    },

    valCompiled(key) {
      return (key) => {
        const valuesCompiled = this.item.valuesCompiled;
        return valuesCompiled && valuesCompiled[key]
          ? valuesCompiled[key]
          : this.val[key];
      };
    },
    imgHeight() {
      if (!this.imageRatio) {
        return;
      }
      // check forceRecalc to allow us to trigger re-calculating this
      // when clientWidth changes
      return this.forceRecalc && this.$el.clientWidth / this.imageRatio;
    },

    imgSrc() {
      return this.val.image;
    },

    summary() {
      return this.item.title;
    },

    definition() {
      return this.$store.getters['items/type'](this.item.type) || {};
    },

    editing() {
      return this.item.editing || this.definition.inline_edits;
    },
  },

  watch: {
    imgSrc(src) {
      if (src) {
        this.calcImageRatio();
      }
    },
  },

  methods: {
    alpha(n) {
      return String.fromCharCode(97 + n).toUpperCase();
    },
    // Calculate image ratio for media
    calcImageRatio() {
      let src = this.val.image;
      if (!this.$el || !src || this._calculating == src) {
        return;
      }
      this._calculating = src;
      let d = document,
        b = document.getElementsByTagName('body')[0],
        i = d.createElement('img');

      i.src = src;
      extend(i.style, {
        position: 'absolute',
        left: '-9999px',
        bottom: '0',
      });

      //receives event
      i.onload = () => {
        let width = i.width,
          height = i.height;
        this.setImageRatio(width / height);
        b.removeChild(i);
      };

      b.appendChild(i);
    },
    setImageRatio(ratio) {
      // Prevent setting until element has rendered
      // since vue can't watch clientWidth directly
      if (!this.$el.clientWidth) {
        setTimeout(() => {
          this.setImageRatio(ratio);
        }, 16);
        return;
      }
      this.imageRatio = ratio;
    },
    recalcImgHeight() {
      this.forceRecalc = Date.now();
    },
    focusFirstInput() {
      if (!this.$el) {
        setTimeout(() => {
          this.focusFirstInput();
        }, 50);
      }
      let fields = this.$el.getElementsByClassName('form-fields')[0] || false;

      if (!fields) {
        return;
      }

      let inputs = fields.getElementsByClassName('input-group__input'),
        first = inputs.length ? inputs[0] : null;

      if (first) {
        // input is always the first and only child
        let el = first.children[0];
        el.focus();
        if (el.select) {
          el.select();
        }
      }
    },
    updateItem(val) {
      this.$emit('update', val);
    },
  },

  mounted: function () {
    if (this.val.image) {
      this.calcImageRatio();

      window.addEventListener('resize', () => {
        this.recalcImgHeight();
      });
    }

    if (!this.taking) {
      this.focusFirstInput();
    }
  },
};
